<ng-container *transloco="let t">
  @for(message of unreadMessages;track $index){
  <div class="mailbox-list-item" [class.unread]="isUnread">
    <div class="mailbox-list-item__date-time">
      <span>{{message.created | date:'dd/MM/yyyy'}} </span>
      <span>{{message.created | date:'hh:MM'}}</span>
    </div>
    <div class="mailbox-list-item__content">
      <div class="mailbox-list-item__sender">
        {{message.senderName}}
      </div>
      <div class="mailbox-list-item__subject">
        {{message.title}}
      </div>
      <div class="mailbox-list-item__message trim-text-fourth-line">
        {{message.body}}
      </div>
    </div>
    <div class="mailbox-list-item__cta">
      <app-rounded-button [label]="t('app.common.reply')"
                          [btnClass]="'rounded-button--black-outline'"/>
    </div>
  </div>
  }
</ng-container>
